import { Route } from "react-router-dom";
import StudentLegacyRedirect from "@/components/shared/StudentLegacyRedirect";

/**
 * Single source of truth for legacy student-area redirects.
 *
 * Mounted on BOTH the platform host (`/:slug/*`) and the custom academy
 * domain (`/*` under `CustomDomainStudentAreaGate`) so any future legacy
 * route added here works on both surfaces automatically.
 *
 * Each entry maps a deprecated path to its canonical equivalent. The
 * `StudentLegacyRedirect` helper resolves slug/host so the produced URL
 * is always correct on the active host.
 *
 * Returns an array of <Route> elements so it can be spread inside any
 * parent <Routes> tree.
 */
export default function studentLegacyRedirectRoutes() {
  return [
    // Learning
    <Route key="lr-my-courses" path="my-courses" element={<StudentLegacyRedirect to="learning/courses" />} />,
    <Route key="lr-my-courses-id" path="my-courses/:courseId" element={<StudentLegacyRedirect to="learning/courses/:courseId" />} />,
    <Route key="lr-my-courses-quiz" path="my-courses/:courseId/quiz/:quizId" element={<StudentLegacyRedirect to="learning/courses/:courseId/quiz/:quizId" />} />,
    <Route key="lr-my-sessions" path="my-sessions" element={<StudentLegacyRedirect to="learning/sessions" />} />,
    <Route key="lr-free-access" path="free-access" element={<StudentLegacyRedirect to="learning/free-access" />} />,

    // Shop
    <Route key="lr-my-purchases" path="my-purchases" element={<StudentLegacyRedirect to="shop/my-purchases" />} />,
    <Route key="lr-my-purchases-id" path="my-purchases/:productId" element={<StudentLegacyRedirect to="shop/my-purchases/:productId" />} />,
    <Route key="lr-explore" path="explore" element={<StudentLegacyRedirect to="shop/explore" />} />,
    <Route key="lr-explore-id" path="explore/:productId" element={<StudentLegacyRedirect to="shop/explore/:productId" />} />,
    <Route key="lr-my-memberships" path="my-memberships" element={<StudentLegacyRedirect to="shop/membership" />} />,

    // Connect
    <Route key="lr-inbox" path="inbox" element={<StudentLegacyRedirect to="connect/inbox" />} />,
    <Route key="lr-invites" path="invites" element={<StudentLegacyRedirect to="connect/invites" />} />,
    <Route key="lr-notifications" path="notifications" element={<StudentLegacyRedirect to="connect/notifications" />} />,
  ];
}
